import { Box, BoxProps, ImageProps } from '@jfs/ui-new'
import React, { FC } from 'react'
import { GridContainerList } from '../../../../components/GridContainerList'
import { PAYMENT_MODE_SUBTYPES } from '../../../../utils/constants'

interface WalletProps {
  isAllChecked: boolean
  isEdit?: boolean
  setIsAllChecked: (isChecked: boolean) => void
}

const WalletContainer: FC<WalletProps> = ({ isAllChecked, isEdit, setIsAllChecked }: WalletProps) => {
  const styles = netbankingStyles()

  return (
    <Box nativeID="showListScrollBar" {...styles.container}>
      <GridContainerList
        type={PAYMENT_MODE_SUBTYPES.WALLET}
        isAllChecked={isAllChecked}
        isEdit={isEdit}
        setIsAllChecked={setIsAllChecked}
      />
    </Box>
  )
}

const netbankingStyles = () => ({
  container: {
    flex: 1,
    overflowY: 'auto',
    paddingVertical: 16,
  } as BoxProps,
  imageView: {
    height: 24,
    width: 24,
  } as ImageProps,
})

export { WalletContainer }
